import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { useRouter } from "vue-router";
import { ElMessage, ElLoading } from "element-plus"; // 引入 ElLoading

const router = useRouter();

// 创建 axios 实例
const service: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// ---------- 加载状态管理 ----------
let loadingInstance: ReturnType<typeof ElLoading.service> | null = null;
let requestCount = 0; // 当前活跃请求数

const showLoading = () => {
  if (!loadingInstance) {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      text: "加载中...",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }
};

const hideLoading = () => {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
};

// 请求计数器操作
const addRequest = () => {
  requestCount++;
  if (requestCount === 1) {
    showLoading();
  }
};

const removeRequest = () => {
  requestCount--;
  if (requestCount <= 0) {
    requestCount = 0;
    hideLoading();
  }
};
// ---------------------------------

// 请求拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 显示加载状态
    addRequest();

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => {
    // 请求错误时也要减少计数
    removeRequest();
    console.error("请求错误:", error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    // 无论业务状态如何，先减少计数
    removeRequest();

    const res = response.data;

    // 401 未登录
    if (res.status == 401) {
      ElMessage.error("请先登录");
      router.push("/login");
      return Promise.reject(new Error("未登录"));
    }

    // 业务状态码不为 200 时视为错误
    if (res.status !== 200) {
      console.error("业务错误:", res.msg || "Error");
      return Promise.reject(new Error(res.msg || "Error"));
    }

    return res;
  },
  (error: any) => {
    // 响应错误时减少计数
    removeRequest();

    console.error("响应错误:", error);

    if (error.response && error.response.data) {
      const res = error.response.data;
      // 注意原代码拼写错误：res.mag -> res.msg
      return Promise.reject(new Error(res.msg || "请求失败"));
    }

    return Promise.reject(new Error("网络连接异常，请检查网络"));
  },
);

export default service;
